import { LocalizedText } from '@mews/framework/localization';
import { BusinessComponentsTextKey as TextKey } from '../../utils/BusinessComponentsTextKey';
import {
    CardTypeListContainer,
    Container,
    LockIcon,
    LockIconContainer,
    PaymentGateTitle,
    SecuredContainer,
} from './style';
import { PaymentCardBannerProps } from './types';

export const PaymentCardBanner: React.FC<PaymentCardBannerProps> = ({ isMerchant, children }) => (
    <Container>
        <LockIconContainer>
            <LockIcon />
            {isMerchant ? (
                <SecuredContainer>
                    <LocalizedText textKey={TextKey.SecuredWith} /> <br />
                    <PaymentGateTitle>
                        <LocalizedText textKey={TextKey.MewsMerchant} />
                    </PaymentGateTitle>
                </SecuredContainer>
            ) : null}
        </LockIconContainer>
        <CardTypeListContainer>{children}</CardTypeListContainer>
    </Container>
);
